var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CaseCard',{attrs:{"color":"blue lighten-3","icon":"mdi-format-list-checks","item":_vm.item,"to":_vm.to,"departments":_vm.metadata.departments,"subject-areas":_vm.metadata.subjectAreas,"active-departments":_vm.item.departments.map((d) => d.value),"active-subject-areas":_vm.item.subjectAreas.map((s) => s.value),"hide-status":_vm.hideStatus}})
}
var staticRenderFns = []

export { render, staticRenderFns }